export default __webpack_public_path__ + "static/media/image12.c514fefb.svg";